import {userMention} from "../extensions/userMention.js";
import {appendMarkdown} from "./appendMarkdown.js";

export function appendUserMention(username) {
  return ({state, dispatch}) => {
    dispatch({
      ...appendMarkdown(state, userMention(username) + ': '),
      userEvent: "input.appendUserMention"
    });
  };
}
